/**
 * GA4 (gtag) — per-seller, opt-in via public API + consent. Fail-safe: never throws.
 */

let scriptPromise = null;
let initializedMeasurementId = null;
let gtagReady = false;

function ensureDataLayer() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

export function loadGoogleAnalyticsScript(measurementId) {
  if (typeof window === "undefined" || !measurementId) {
    return Promise.resolve(false);
  }

  ensureDataLayer();

  if (gtagReady && initializedMeasurementId === measurementId) {
    return Promise.resolve(true);
  }

  if (scriptPromise && initializedMeasurementId === measurementId) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve) => {
    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      if (!ok) scriptPromise = null;
      gtagReady = ok;
      if (ok) initializedMeasurementId = measurementId;
      resolve(ok);
    };

    try {
      const existing = document.querySelector(
        `script[src*="googletagmanager.com/gtag/js"]`
      );
      if (existing && initializedMeasurementId === measurementId && gtagReady) {
        finish(true);
        return;
      }

      window.gtag("js", new Date());
      window.gtag("config", measurementId, { send_page_view: false });

      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
      s.onload = () => finish(true);
      s.onerror = () => finish(false);
      document.head.appendChild(s);
    } catch {
      finish(false);
    }
  });

  return scriptPromise;
}

export async function initGoogleAnalytics(measurementId) {
  if (!measurementId) return false;
  try {
    return await loadGoogleAnalyticsScript(measurementId);
  } catch {
    return false;
  }
}

export function trackGaPageView() {
  try {
    if (!gtagReady || !initializedMeasurementId || typeof window.gtag !== "function") {
      return;
    }
    window.gtag("event", "page_view", {
      page_path: `${window.location.pathname}${window.location.search}`,
      page_title: document.title || "",
    });
  } catch {
    /* ignore */
  }
}

export function resetGoogleAnalyticsSession() {
  scriptPromise = null;
  initializedMeasurementId = null;
  gtagReady = false;
}

export function isGoogleAnalyticsReady() {
  return gtagReady && Boolean(initializedMeasurementId);
}
